export default "__VITE_ASSET__Cne1xjeT__"